import React, { useEffect } from 'react'

import FeedbackAlert from './FeedbackAlert'
import { FEEDBACK_ALERT_DURATION_MS } from './constants/feedbackAlertConstants'
import {
  buildFeedbackAlertSx,
  resolveFeedbackAlertStyle
} from './helpers/feedbackAlertHelpers'

export const ACTION_FEEDBACK_DURATION_MS = FEEDBACK_ALERT_DURATION_MS

/**
 * Variante inline para feedback inmediato de una accion.
 *
 * Se usa cuando el mensaje debe vivir dentro del layout, por ejemplo debajo de un header
 * o junto a un formulario. Si necesitas un aviso flotante, usa `TimedToastAlert`.
 */
export default function ActionFeedbackAlert({
  alert,
  onClose,
  isMobileLayout = false,
  placement = 'inline',
  sx = {}
}) {
  useEffect(() => {
    if (!alert?.message || typeof onClose !== 'function') return undefined

    const timeoutId = window.setTimeout(() => {
      onClose()
    }, ACTION_FEEDBACK_DURATION_MS)

    return () => window.clearTimeout(timeoutId)
  }, [alert?.id, alert?.message, onClose])

  if (!alert) return null

  const severity = alert.severity || 'success'
  const style = {
    ...resolveFeedbackAlertStyle(severity),
    ...(severity === 'warning' ? { borderWidth: 2, fontWeight: 700 } : {})
  }
  const isHeaderRight = placement === 'header-right' && !isMobileLayout

  return (
    <FeedbackAlert
      id={alert.id}
      message={alert.message}
      severity={severity}
      onClose={onClose}
      durationMs={ACTION_FEEDBACK_DURATION_MS}
      sx={buildFeedbackAlertSx(style, ACTION_FEEDBACK_DURATION_MS, {
        inline: true,
        isMobileLayout,
        position: {
          type: isHeaderRight ? 'absolute' : 'relative',
          right: isHeaderRight ? 0 : undefined,
          top: isHeaderRight ? '50%' : undefined,
          transform: isHeaderRight ? 'translateY(-50%)' : undefined,
          zIndex: 1
        },
        width: isMobileLayout ? '100%' : isHeaderRight ? 'fit-content' : '100%',
        minHeight: isMobileLayout ? 36 : 40,
        mt: isMobileLayout ? 1.25 : 0,
        mb: 0,
        px: isMobileLayout ? 1.5 : 2,
        py: isMobileLayout ? 1 : 1.25,
        borderRadius: '4px',
        boxShadow: 'none',
        messageFontSize: isMobileLayout ? 13 : 15,
        messageLineHeight: 1.35,
        closeButtonMinimal: true,
        progressKeyframeName: 'actionAlertProgress',
        extraSx: sx
      })}
    />
  )
}
